import { replaceAll } from '../../global/helpers/string-helpers';
import { setCurrentContext, setMapFilter, setReportContext, setSelectedDio, setSelectedRegion } from './clergy-comp-report-slice';
import { CurrentContext, ReportContext } from './models';

class DomesticMapSelection {

	public currentRegion: string;

	public currentDio: string;
}

export const domesticMapSelection = new DomesticMapSelection();



export function provHover(opacity: string, element: HTMLElement) {
	element.style.setProperty('opacity', opacity);
}

const transformMap = {
	p1: 'matrix(4.405994313790387,0,0,4.405994313790387,-1776.8314928918983,579.2638377390437)',
	p2: 'matrix(4.631329334734805,0,0,4.631329334734805,-1511.179550627004,459.08731649305884)',
	p3: 'matrix(5.0139055682550575,0,0,5.0139055682550575,-1394.3903576313703,317.21327997996923)',
	p4: 'matrix(1.9787551258264493,0,0,1.9787551258264493,-423.14020224398,-86.2641384883137)',
	p5: 'matrix(2.345071648135735,0,0,2.345071648135735,-403.77319208343704,237.3120612517419)',
	p6: 'matrix(2.338243939541782,0,0,2.338243939541782,127.56245427779015,272.0129239989469)',
	p7: 'matrix(1.9550770632669714,0,0,1.9550770632669714,11.540491512614462,-46.67879201656615)',
	p8: 'matrix(1.2567438664850656,0,0,1.2567438664850656,379.18951993458336,46.77181325765504)',
};

function centerMap(prov: HTMLElement, svg) {
	const region = prov.getAttribute('prov');
	svg.setAttribute('transform', transformMap[region]);
}

export function handleRegionClick(prov: HTMLElement, regions: HTMLElement[], svg, dispatch, force = false) {
	const selectedRegion = prov.getAttribute('prov');
	if (domesticMapSelection.currentRegion !== selectedRegion || force) {
		prov.setAttribute('class', '');
		centerMap(prov, svg);
		dispatch(setCurrentContext(CurrentContext.REGION));
		dispatch(setReportContext(ReportContext.DIO));
		dispatch(setSelectedDio(null));
		dispatch(setSelectedRegion(selectedRegion));
		dispatch(setMapFilter({ dio: null, region: selectedRegion }));
		const current = regions.filter(a => a.getAttribute('prov') === domesticMapSelection.currentRegion);
		current[0]?.childNodes.forEach(c => {
			if (c.nodeName === 'g') {
				(c as HTMLElement).removeAttribute('class');
			}
		});
		domesticMapSelection.currentRegion = selectedRegion;
		domesticMapSelection.currentDio = null;

		prov.childNodes.forEach(child => {
			if (child.nodeName === 'text') {
				(child as HTMLElement).setAttribute('class', 'faded-numeral');
			}
		});
	}

	regions?.forEach((region) => {
		if (region.getAttribute('prov') !== selectedRegion) {
			region.setAttribute('class', 'grey-light');
			region.childNodes.forEach(child => {
				if (child.nodeName === 'text') {
					(child as HTMLElement).setAttribute('class', '');
				}
			});
		}
	});

}

export function handleDioClick(dio: HTMLElement, region: HTMLElement, dispatch) {
	const selectedDio = dio.getAttribute('id');
	const parentRegion = region.getAttribute('prov');
	if (domesticMapSelection.currentDio !== selectedDio && parentRegion === domesticMapSelection.currentRegion) {
		dispatch(setCurrentContext(CurrentContext.DIOCESE));
		dispatch(setReportContext(ReportContext.DIO));
		dispatch(setSelectedDio(selectedDio));
		dispatch(setMapFilter({ dio: selectedDio, region: parentRegion }));
		(dio as HTMLElement).removeAttribute('class');
		domesticMapSelection.currentDio = selectedDio;
		region?.childNodes.forEach(c => {
			if (c.nodeName === 'g' && (c as HTMLElement)?.getAttribute('id') !== selectedDio) (c as HTMLElement).setAttribute('class', 'grey-dark');
		});
	}
}

export function handleInternationalDioClick(prov: HTMLElement, allDio: HTMLElement[], dispatch) {
	dispatch(setCurrentContext(CurrentContext.INTERNATIONDIO));
	dispatch(setReportContext(ReportContext.DIO));
	const selectedId = prov.getAttribute('id');
	dispatch(setSelectedDio(selectedId));
	dispatch(setMapFilter({ dio: selectedId, region: null }));
	allDio?.forEach(dio => {
		dio.setAttribute('class', selectedId === dio.getAttribute('id') ? `${dio.getAttribute('class')?.replace('grey-dark', '')}` : `${replaceAll(dio.getAttribute('class'), ' grey-dark', '')} grey-dark`);
	});
}
